module.exports = __webpack_public_path__ + "img/aiMark.ea6e539a.svg";